export function getCookie(name: string): string | null {
  if (!document.cookie) {
    return null;
  }
  
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

export function getCSRFToken(): string | null {
  return getCookie('csrftoken');
}